"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const buildURL = require("./buildURL.cjs");
const buildPixelDensitySrcSet = (url, { pixelDensities, ...params }) => {
  return pixelDensities.map((dpr) => {
    return `${buildURL.buildURL(url, { ...params, dpr })} ${dpr}x`;
  }).join(", ");
};
exports.buildPixelDensitySrcSet = buildPixelDensitySrcSet;
//# sourceMappingURL=buildPixelDensitySrcSet.cjs.map
